<template>
  <div id="user_infors_enters_outer">
    <div style="font-weight: bold;font-size: 1.3rem;text-align: center;">
      上传报名材料<br>
      <span style="font-size: 1rem">(1/3)</span>
    </div>

    <div class="text-input">
      <div class="left">*姓名：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.name" placeholder="请输入姓名"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*是否为内推：</div>
      <div class="right">
        <el-radio v-model="user.internal" :label="0">否</el-radio>
        <el-radio v-model="user.internal" :label="1" >是</el-radio>
        <el-input placeholder="请输入推荐人/机构名称" v-model="user.recommendPerson" style="max-width: 150px;"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*性别：</div>
      <div class="right">
        <el-radio v-model="user.gender" :label="1">男</el-radio>
        <el-radio v-model="user.gender" :label="2" >女</el-radio>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*出生年月日：</div>
      <div class="right">
        <datepicker :format="'yyyy-MM-dd'"
                     v-model="user.birthday"
                     :placeholder="'请选择您的生日'"
                     :language="zh"
        ></datepicker>
      </div>
    </div>



    <div class="text-input">
      <div class="left">*身份证号：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.naturalID" placeholder="请输入您的身份证号码"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*个人邮箱：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.email" placeholder="请输入您的邮箱"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*所属行业：</div>
      <div class="right">
        <el-select v-model="user.industry" placeholder="请选择所属行业">
          <el-option v-for="(item, index) in industryList" :label="item" :value="item" :key="'enter_industry_' + index" ></el-option>
        </el-select>
      </div>
    </div>


    <div class="text-input">
      <div class="left">*所在单位：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.workSpace" placeholder="请输入您的单位名称"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*当前职务：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.duty" placeholder="请输入您的职务名称"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">执教年限：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.workYears" placeholder="请输入您的执教年限"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left">最好成绩：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.goodJobs" placeholder="请输入您的最好成绩"></el-input>
      </div>
    </div>

    <div class="text-input">
      <div class="left" style="align-self: flex-start;margin-top: 10px;">*服装尺码：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.bodyData" placeholder="请输入您的身高(cm)体重(kg)，以半角逗号分割"></el-input>
        <div style="width: 100%;margin-top: 10px;">
          <el-select v-model="user.jacket" placeholder="请选择上衣尺码">
            <el-option v-for="(item, index) in clothSizesList" :value="item" :label="item" :key="'jacket_item_' + index"></el-option>
          </el-select>
        </div>

        <div style="width: 100%;margin-top: 10px;">
          <el-select v-model="user.trousers" placeholder="请选择裤子尺码">
            <el-option v-for="(item, index) in clothSizesList" :value="item" :label="item" :key="'trouser_item_' + index"></el-option>
          </el-select>
        </div>
      </div>
    </div>


    <div style="margin-top: 30px;align-self: flex-start;padding-left: 10px;">
      <div>*上传身份证<span style="color: #fc1a34;">照片面</span>图片</div>


      <el-upload
        class="files-upload"
        action="https://api.shslqxh.com/upload/keepname"
        :headers="headers"
        name="files"
        multiple
        :limit="limit"
        accept="image/png, image/jpg"
        list-type="picture-card"
        :before-remove="beforeRemoveFile"
        :on-exceed="handleExceed"
        :on-remove="handleFileRemove"
        :on-preview="handlePreview"
        :on-success="handleUploadSuccess" >
        <el-button size="small" round>点击上传</el-button>
      </el-upload>

    </div>


    <div class="text-input" style="margin-top: 30px;">
      <div class="left">*联系电话：</div>
      <div class="right mobile-and-code">
        <el-input class="content-input" v-model="user.mobile" placeholder="请输入联系人电话"></el-input>
        <el-button v-if="timeValue == 0" style="margin-left: 10px;background-color: #fc1a34;border: none;color: white;" round size="small" @click="codeButtonClicked">获取验证码</el-button>
        <el-button v-else style="margin-left: 10px;background-color: #fc1a34;border: none;color: #ddd;padding-left: 10px;padding-right: 10px;" round disabled>{{timeValue}}s重新获取</el-button>
      </div>
    </div>

    <div class="text-input">
      <div class="left">*短信验证码：</div>
      <div class="right">
        <el-input class="content-input" v-model="user.verificationCode" placeholder="请输入短信验证码"></el-input>
      </div>
    </div>

    <el-button round
               @click="submitButtonClicked"
               style="color: white;background-color: #fc1a34;border: none;width: 150px;margin-top: 30px;">下一步</el-button>

  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import Lzh from "vuejs-datepicker/dist/locale/translations/zh";
export default {
  name: "UserInforEnter",
  components: {
    Datepicker,
  },
  data() {
    return {
      headers: {},
      limit: 2,
      fileList: [

      ],
      timeValue: 0,
      timerFlag: null,

      zh: Lzh,

      clothSizesList: [
        'XS',
        'S',
        'M',
        'L',
        'XL',
        '2XL',
        '3XL',
        '4XL',
        '5XL',
        '6XL'
      ],

      industryList: [
        '体育系统运动队',
        '大学',
        '中学',
        '小学',
        '社会培训机构',
        '在校学生',
        '其他'
      ],

      user: {
        name: '',
        internal: 0,
        recommendPerson: '',
        gender: 1,
        birthday: '',
        naturalID: '',
        email: '',
        industry: '',
        workSpace: '',
        duty: '',
        workYears: '',
        goodJobs: '',
        bodyData: '',
        jacket: '',
        trousers: '',
        mobile: '',
        verificationCode: '',
      }

    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    trainId() {
      return this.$route.params.courseId;
    }
  },

  mounted() {
    let token = this.$store.state.dataStore.getToken();
    this.headers.token = token;
  },

  methods: {
    submitButtonClicked() {
      let user = this.user;
      let params = {};
      params.step = 1;
      params.productId = this.trainId;
      params.trainingEnrollDetail = {};

      let _this = this;
      let dealWithStringParams = function (key, value, message) {
        let tmp = value.removeBlanks();
        if (tmp == '') {
          _this.$toast(message);
          return false;
        }
        params.trainingEnrollDetail[key] = value;
        return true;
      };

      if (!dealWithStringParams('name', user.name, '请输入姓名')) {
        return;
      }

      let internal = user.internal;
      params.trainingEnrollDetail.approved = internal;

      if (internal != 0) {
        if (!dealWithStringParams('references', user.recommendPerson, '请输入推荐人或机构！')) {
          return;
        }
      }
      let gender = user.gender;
      params.trainingEnrollDetail.sex = gender;

      let birthday = user.birthday;
      if (birthday == '') {
        this.$toast('请输入您的出生日期！');
        return;
      }
      birthday = this.$moment(birthday).format('yyyy-MM-DD');
      params.trainingEnrollDetail.birthday = birthday;


      if (!dealWithStringParams('idNo', user.naturalID, '请输入您的身份证号码！')) {
        return;
      }

      if (!dealWithStringParams('email', user.email, '请输入您的邮箱！')) {
        return;
      }

      if (!dealWithStringParams('industry', user.industry, '请选择所属行业！')) {
        return;
      }

      if (!dealWithStringParams('unit', user.workSpace, '请输入您的单位名称！')) {
        return;
      }

      if (!dealWithStringParams('post', user.duty, '请输入您的职务名称！')) {
        return;
      }

      let workYears = user.workYears.removeBlanks();
      params.trainingEnrollDetail.coaching = workYears;

      let goodJobs = user.goodJobs.removeBlanks();
      params.trainingEnrollDetail.bestResults = goodJobs;


      let clothSize = '';
      let bodyData = user.bodyData.removeBlanks();
      if (bodyData == '') {
        this.$toast('请输入您的身高体重！');
        return;
      }
      clothSize += bodyData;

      let jacket = user.jacket;
      if (jacket == '') {
        this.$toast('请选择您的上衣尺码！');
        return;
      }
      clothSize +=  `,${jacket}`;

      let trousers = user.trousers;
      if (trousers == '') {
        this.$toast('请选择您的裤子尺码！');
        return;
      }
      clothSize +=  `,${trousers}`;
      params.trainingEnrollDetail.size = clothSize;


      let material = '';
      if (this.fileList.length == 0 ) {
        this.$toast('请上传身份证照片面！');
        return;
      }

      for (let i = 0; i < this.fileList.length; i++) {
        let item = this.fileList[i];
        if (i > 0) {
          material += ',' + item.url;
        } else {
          material += item.url;
        }
      }

      params.trainingEnrollDetail.idCard = material;

      let mobile = user.mobile.removeBlanks();
      if (mobile == '') {
        this.$toast('请输入联系人手机号！');
        return;
      }

      if (!mobile.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }
      params.trainingEnrollDetail.mobile = mobile;


      let verificationCode = user.verificationCode.removeBlanks();
      if (verificationCode == '') {
        this.$toast('请输入验证码！');
        return;
      }
      params.verificationCode = verificationCode;

      let currentUser = this.$store.state.dataStore.getUser();
      if (currentUser == null) {
        this.$toast('您尚未登录！');
        return;
      }
      let userId = currentUser.userId;
      if (userId == undefined) {
        this.$toast('登录异常，请先登出，再登录！');
        return;
      }
      params.trainingEnrollDetail.userId = userId;

      this.$emit('next-step-click', params);
    },

    codeButtonClicked() {
      let mobile = this.user.mobile.removeBlanks();
      if (mobile == '') {
        this.$toast('请输入联系人手机号！');
        return;
      }

      if (!mobile.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let params = {
        phoneNumbers: mobile,
        tag: 'order',
      }
      let _this = this;
      this.requestLoading = true;
      this.httpManager.ajax.smsSend(params, function (data) {
        _this.requestLoading = false;
        if (data.code == 0) {
          _this.timeValue = 60;
          _this.timerFlag = setInterval(_this.codeSecondOperate, 1000);
          return;
        }
        _this.$toast('发送失败！');
      }, function (data) {
        _this.requestLoading = false;
        _this.$toast('发送失败，请重试！');
      });
    },

    codeSecondOperate() {
      this.timeValue --;
      if (this.timeValue <= 0) {
        this.clearTimeFlag();
      }
    },
    clearTimeFlag() {
      if (this.timerFlag != null) {
        clearInterval(this.timerFlag);
        this.timerFlag = null;
        this.timeValue = 0;
      }
    },

    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${ this.limit } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemoveFile(file, fileList) {
      return this.$confirm(`确定移除${ file.name }吗？`);
    },
    handleFileRemove(file ,fileList) {
      let url = file.response;
      let index = this.fileList.findIndex(function (item) {
        return item.url == url;
      });
      this.fileList.splice(index, 1);
    },
    handlePreview(file) {

    },
    handleUploadSuccess(res, file) {
      if (typeof res == 'string') {
        let name = file.name;
        let url = res;
        let obj = {
          name,
          url
        };
        this.fileList.push(obj);
      }
    }
  }
}
</script>

<style scoped>

  #user_infors_enters_outer {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  .files-upload {
    text-align: center;
    margin-top: 15px;
  }

  @media screen and (min-width: 375px){
    .files-upload {
      text-align: left;
    }
  }

  #user_infors_enters_outer .el-select {
    max-width: 400px;
    width: 100%;
  }

  #user_infors_enters_outer .files-upload /deep/ input[type='file'] {
    display: none;
  }

  #user_infors_enters_outer .files-upload .el-button {
    background-color: #fc1a34;
    color: white;
    border: none;
    margin-top: 10px;
  }

  #user_infors_enters_outer .text-input {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  #user_infors_enters_outer .text-input .left {
    padding: 0;
    font-size: 1rem;
    display: inline;
    width: 30%;
    text-align: right;
  }

  #user_infors_enters_outer .text-input .right {
    margin-left: 15px;
    width: 60%;
    position: relative;

  }

  @media screen and (min-width: 768px) {
    #user_infors_enters_outer .text-input .left {
      width: 112px;
    }

    #user_infors_enters_outer .text-input .right {
      margin-left: 15px;
      width: inherit;
    }
  }


  #user_infors_enters_outer .text-input:not(:first-child) {
    margin-top: 15px;
  }

  #user_infors_enters_outer .text-input .input-label {
    padding: 0;
    font-size: 1rem;
    display: inline;
    width: 80px;
    text-align: right;
  }


  #user_infors_enters_outer .mobile-and-code {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-self: center;
  }


  #user_infors_enters_outer  /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #user_infors_enters_outer  /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
    border-color: #fc1a34;
    background-color: #fc1a34;
  }
  #user_infors_enters_outer  /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }


  #user_infors_enters_outer /deep/ .vdp-datepicker {
    position: static;
  }

  #user_infors_enters_outer /deep/ .vdp-datepicker .vdp-datepicker__calendar {
    right: -5px;
  }

  #user_infors_enters_outer /deep/ .vdp-datepicker {
    max-width: 400px;
  }

  #user_infors_enters_outer /deep/ .vdp-datepicker input {
    padding: 10px 10px;
    border-width: 1px;
    border-style: solid;
    width: 85%;
    border-color: #ddd;
    border-radius: 4px;
    width: 100%;
  }

  #user_infors_enters_outer /deep/ .vdp-datepicker input::placeholder {
     color: #999;
  }


  #user_infors_enters_outer /deep/ .vdp-datepicker input:hover {
    border-color: #fc1a34;
  }

  #user_infors_enters_outer /deep/ .vdp-datepicker input:focus {
    border-color: #fc1a34;
  }

  #user_infors_enters_outer .el-input {
    max-width: 400px;
  }

  #user_infors_enters_outer /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

  @media screen and (min-width: 768px) {
    #user_infors_enters_outer {
      padding-left: 30px;
      padding-right: 30px;
    }

    #user_infors_enters_outer /deep/ .vdp-datepicker {
      position: relative;
    }

    #user_infors_enters_outer /deep/ .vdp-datepicker .vdp-datepicker__calendar {
      right: auto;
      left: 0;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/course/UserInforEnter.vue